import { useDownloadClientQuestionnaire as useDownloadClientQuestionnaireApi } from 'api/requests';
import { downloadBase64File } from 'helpers';
import { useServerErrorNotify } from 'hooks';

export const useDownloadClientQuestionnaire = () => {
  const { downloadClientQuestionnaire, error } =
    useDownloadClientQuestionnaireApi();

  const handleDownloadQuestionnaire = async (clientId: string) => {
    const res = await downloadClientQuestionnaire(clientId);
    if (res) {
      downloadBase64File(res, 'application/pdf');
    }
  };

  useServerErrorNotify(error);

  return {
    error,
    downloadClientQuestionnaire: handleDownloadQuestionnaire,
  };
};
